<template>
  <div>
    <multiselect
      class="multiselect-project"
      v-model="selectedProject"
      :options="filteredProjects"
      :placeholder="resolvedPlaceholder"
      :disabled="disabled"
      :allow-empty="allowEmpty"
      track-by="number"
      :deselectLabel="$t('deselectLabel')"
      selectLabel=""
      selectedLabel=""
      :internal-search="false"
      :show-labels="true"
      @open="onProjectDropdownOpen"
      @search-change="onProjectSearch"
    >
      <template slot="singleLabel" slot-scope="{ option }">
        <div v-if="option">
          #{{ option.number.toString().padStart(4, '0') }} - {{ option.customer.lastname }},
          {{ option.customer.firstname }}
        </div>
      </template>
      <template slot="option" slot-scope="{ option }">
        <div>
          #{{ option.number.toString().padStart(4, '0') }}: {{ option.customer.lastname }},
          {{ option.customer.firstname }}
        </div>
        <div>
          {{ option.customer.street }} {{ option.customer.streetNumber
          }}<span v-if="option.customer.streetNumberSuffix">{{
            option.customer.streetNumberSuffix
          }}</span
          >, {{ option.customer.zip }}
          {{ option.customer.city }}
        </div>
      </template>
      <template slot="noResult">
        <div>{{ $t('no_results') }}</div>
      </template>
    </multiselect>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Multiselect from 'vue-multiselect';

const PROJECT_SELECTION_PAGINATION = { skip: 0, pageSize: 25 };

export default {
  components: {
    Multiselect,
  },
  props: {
    project: {
      type: Object,
      default: null,
    },
    allowEmpty: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: null,
    },
  },
  model: {
    prop: 'project',
    event: 'select',
  },
  data() {
    return {
      filteredProjects: [],
      search: null,
    };
  },
  computed: {
    selectedProject: {
      get() {
        return this.project;
      },
      set(project) {
        this.$emit('select', project);
      },
    },
    resolvedPlaceholder() {
      return this.placeholder || this.$t('search');
    },
  },
  methods: {
    ...mapActions(['fetchProjectSelection']),
    ensureSelectedProjectIsAvailable() {
      if (!this.project) {
        return;
      }

      const hasSelectedProject = this.filteredProjects.some(
        (filteredProject) => filteredProject.number === this.project.number
      );

      if (!hasSelectedProject) {
        this.filteredProjects = [this.project, ...this.filteredProjects];
      }
    },
    async onProjectSearch(query) {
      this.search = query || null;
      await this.loadProjectData();
    },
    async onProjectDropdownOpen() {
      await this.loadProjectData();
    },
    /** Narrow project selection in both modes (number and customer, see feature page projekt-montage). */
    async loadProjectData() {
      this.filteredProjects = await this.fetchProjectSelection({
        search: this.search,
        pagination: PROJECT_SELECTION_PAGINATION,
      });
      this.ensureSelectedProjectIsAvailable();
    },
  },
  watch: {
    project() {
      this.ensureSelectedProjectIsAvailable();
    },
  },
};
</script>

<style scoped lang="scss">
.multiselect__content-wrapper {
  position: absolute;
}

.multiselect-project {
  position: relative;
}
</style>
